import * as React from 'react';

import {TEXT_AUTOMATIONS} from '../../constants';
import {useGetTextAutomationsForStage} from '../../graphql/hooks/use-get-text-automations-for-stage';

import {SalesAutomationCardTextAutomation} from '../cards/sales-automation-card-text-automation';

import {StageSingleItemContainer} from './stage-single-item-container';

type Props = {
    parentId: string;
    hideCards: boolean;
};

export function StageCardsTextAutomationsContainer(props: Props) {
    const {isLoading, errorMessage, textAutomations} = useGetTextAutomationsForStage(
        props.parentId
    );

    // Might support multiple, just grabbing first for now
    const textAutomationCards = textAutomations.map((textAutomation) => {
        return (
            <SalesAutomationCardTextAutomation
                key={textAutomation.id}
                // @ts-expect-error
                isHidden={props.hideCards}
                parentId={props.parentId}
                textAutomation={textAutomation}
            />
        );
    });

    return (
        <StageSingleItemContainer
            type={TEXT_AUTOMATIONS}
            isLoading={isLoading}
            errorMessage={errorMessage}
            item={textAutomationCards[0]}
            parentId={props.parentId}
            hideAddCard={props.hideCards}
        />
    );
}
